<template>
  <div class="container">
   <Resultados :proceso="proceso" v-if='proceso'></Resultados>
  </div>
</template>
<script>
import Resultados from './Resultadoscultura.vue'
import apiServices from '../../services/yungol-services'
import {mapState} from 'vuex'

export default {
  data(){
    return {
      proceso: null,
      showPage: false
    }
  },
  computed:{
    ...mapState(["idtoken"]),
  },
  methods:{
    async getData(){
      try {
        if(this.$route.params.id && this.$route.params.filter){
          let filter = atob(atob(this.$route.params.filter))
          filter = JSON.parse(filter)
          let result = null
          let data = {}

          result = await apiServices.get(`cohortecultura/${this.$route.params.id}`)

          data = {
            ...result.data[0],
            filter: filter
          };
          console.log(data)

          this.proceso = data
        }
      }catch (e){
        await this.$store.dispatch("notify", {
          message: `Error al cargar el tablero compartido`,
          type: "is-danger",
        });
      }
    },
  },
  created() {
    if (this.idtoken || this.$route.params.id){
      this.getData();
    }
  },
  watch:{
    idtoken(){
      if (this.idtoken && this.$route.params.id){
        this.getData();
      }
    }
  },
  components:{
    Resultados
  },
  errorCaptured(err, vm, info) {
    console.log({err, vm, info})
    this.$store.dispatch("notify", {
      message: `Hubo un error al cargar el Tablero, intenta de nuevo o reporta este error`,
      type: "is-danger",
    });
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cultura/ResultadoCompartido.vue